import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-bootstrap/lib/Modal';
import Button from 'react-bootstrap/lib/Button';
import i18n from '../../i18n';

import Conversation from '../../models/Conversation';

export default class ReciprocalModal extends React.PureComponent {
    static propTypes = {
        conversation: PropTypes.instanceOf(Conversation).isRequired
    };

    constructor(props) {
        super(props);

        this.state = {
            isReciprocalExchange: this.props.conversation.isMutual(),
            prevConversationId: this.props.conversation.id
        };

        this.onConfirm = this.onConfirm.bind(this);
    }

    onConfirm() {
        this.setState({
            isReciprocalExchange: this.props.conversation.isMutual()
        });
    }

    UNSAFE_componentWillMount() {
        this.setState({
            prevConversationId: this.props.conversation.id
        });
    }

    render() {
        const show =
            this.state.prevConversationId == this.props.conversation.id &&
            !this.state.isReciprocalExchange &&
            this.props.conversation.isMutual() &&
            this.props.conversation.doesInterlocutorWantReciprocalWithoutGP();
        return (
            <Modal show={show} backdrop="static" className="reciprocal-popup">
                <Modal.Body>
                    <div className="row">
                        <div className="col-xs-12">
                            <h2>{i18n.t('exchange:change.to.reciprocal')}</h2>
                        </div>
                        <div className="col-xs-12">
                            <p>
                                {i18n.t('exchange:reciprocal.gp.to.zero', {
                                    name: this.props.conversation.get('interlocutor').get('first_name')
                                })}
                            </p>
                        </div>
                        <div className="col-xs-12">
                            <p>{i18n.t('exchange:adjust.gp.on.reciprocal')}</p>
                        </div>
                    </div>
                    <div className="row actions-row">
                        <div className="col-xs-12">
                            <Button bsStyle="primary" bsSize="large" onClick={this.onConfirm}>
                                {i18n.t('common:gp_popup_button')}
                            </Button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        );
    }
}
